// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_6mh","newExpiryDate":"styles_newExpiryDate__1USoM","footer":"styles_footer__3SVGw"};